import React, { createContext, useState, useEffect } from 'react';
import { clearAuthToken, getAuthToken, setAuthToken } from '../utils/authToken';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const [token, setToken] = useState(() => getAuthToken());

	useEffect(() => {
		const syncToken = () => {
			setToken(getAuthToken());
		};

		const onUnauthorized = () => {
			setToken(null);
		};

		window.addEventListener('storage', syncToken);
		window.addEventListener('auth:unauthorized', onUnauthorized);

		return () => {
			window.removeEventListener('storage', syncToken);
			window.removeEventListener('auth:unauthorized', onUnauthorized);
		};
	}, []);

	const login = (newToken, remember = false) => {
		setAuthToken(newToken, remember);
		setToken(newToken);
	};

	const logout = () => {
		clearAuthToken();
		setToken(null);
	};

	return (
		<AuthContext.Provider value={{ token, login, logout }}>
			{children}
		</AuthContext.Provider>
	);
};
